import styled from 'styled-components';

export const FilterContentWrapper = styled.div`
  & > div:first-child {
    margin-bottom: 14px;
  }

  .ant-form-item {
    margin-bottom: 0;
  }
`;
